import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { userApiEvents } from 'modules/api/user'

export interface UserDetailsState {
  firstName: string
  lastName: string
  idNumber: string
  passport: string
  dateOfBirth: string
  cellNumber: string
  otpFailed: boolean
}

export const initialState: UserDetailsState = {
  firstName: '',
  lastName: '',
  idNumber: '',
  passport: '',
  dateOfBirth: '',
  cellNumber: '',
  otpFailed: false,
}

const userDetailsSlice = createSlice({
  name: 'chatbot/dialogs/userDetails',
  initialState,
  reducers: {
    detailsSubmitted: (state, action: PayloadAction<Partial<UserDetailsState>>) => {
      Object.assign(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder
      .addCase(userApiEvents.currentUserDetails_success, (state, action) => {
        Object.assign(state, action.payload)
      })
      .addCase(userApiEvents.saveDetails_success, (state, action) => {
        Object.assign(state, action.payload)
      })
  },
})

export const { reducer } = userDetailsSlice
export const userDetailsEvents = userDetailsSlice.actions
